import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useState } from "react";
import { CAMPAIGN_STATUS, ENTITYNAME, TOAST_TYPES } from "../../../framework/constant/constant";
import { EditPageHeader } from "../../../components/EditPageHeader";
import * as API from "../../../framework/API/api";
import ToastNotification from "../../../components/ToastNotification";
import { useTranslation } from "../../../locale/useTranslation";

const CampaignStatusPopup = ({ dataItem, onClose }) => {
    
    const lang = useTranslation();
    const campaignStatusData = Object.keys(CAMPAIGN_STATUS).map(key => { return { "_id": CAMPAIGN_STATUS[key], "Description": key } });

    const defaultCampaignStatus = campaignStatusData.filter(status => status._id === CAMPAIGN_STATUS.Pending)[0];
    const [campaignStatus, setCampaignStatus] = useState(dataItem?.campaignStatus || defaultCampaignStatus);

    const onSubmit = async () => {
        try {
            let res = await API.saveData(ENTITYNAME.Campaign, { _id: dataItem._id, campaignStatus: campaignStatus });
            if (res.success) {
                ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Campaign status updated successfully" });
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Failed to update campaign status" });
            }
            onClose();
        } catch (error) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Failed to update campaign status" });
            console.error("Error updating campaign status:", error);
        }
    }

    return (
        <div className='campaign-status-popup'>
            <EditPageHeader onSubmit={onSubmit} onCancel={onClose} showTitle={false} />
            <br />
            <DropDownList
                data={campaignStatusData}
                textField="Description"
                dataItemKey="_id"
                value={campaignStatus}
                onChange={(e) => setCampaignStatus(e.value)}
            />
        </div>
    );
}

export default CampaignStatusPopup;